/**
 * Curated State → City data for the location dropdowns.
 *
 * HealAtHome operates in Kerala, so that list is complete for the district and
 * major towns the demo uses; a handful of other states are included so the
 * State dropdown is realistic and the dependent-City behaviour is visible. The
 * free-text "local area" captures anything finer than city.
 */
export const CITIES_BY_STATE = {
  Kerala: [
    'Kochi',
    'Thiruvananthapuram',
    'Kozhikode',
    'Thrissur',
    'Kollam',
    'Kottayam',
    'Kannur',
    'Palakkad',
    'Malappuram',
    'Alappuzha',
    'Aluva',
    'Kakkanad',
    'Thrippunithura',
    'Kalamassery',
    'Angamaly',
    'Perumbavoor',
    'Muvattupuzha',
    'Cherthala',
  ],
  Karnataka: ['Bengaluru', 'Mysuru', 'Mangaluru', 'Hubballi', 'Belagavi'],
  'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem'],
  Maharashtra: ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Thane'],
  Telangana: ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar'],
  Delhi: ['New Delhi', 'Dwarka', 'Rohini', 'Saket'],
};

export const STATES = Object.keys(CITIES_BY_STATE);

export const citiesOf = (state) => CITIES_BY_STATE[state] || [];

/** Every city across all states, de-duplicated and sorted — the master list a
 *  nurse picks service areas from. */
export const ALL_CITIES = [...new Set(Object.values(CITIES_BY_STATE).flat())].sort();

/** Languages a nurse can list / a patient can filter by. */
export const LANGUAGES = ['Malayalam', 'English', 'Hindi', 'Tamil', 'Kannada', 'Telugu', 'Urdu'];
